import moment from 'moment-timezone'
import * as AT from './_types'
import fetchApi from '../../services/fetchApi'
import tokenStorage from '../../services/token-storage'
import { logException } from '../../services/sentry'

const { REACT_APP_API_BASE_URL } = process.env

export const setCurrentUser = ({
  active_location: activeLocation,
  caller_id_enabled,
  country_code,
  is_practice_admin: isPracticeAdmin,
  locations,
  phone_numbers: phoneNumbers,
  practice_name: practiceName,
  timezone,
  username,
}) => ({
  type: AT.ACCT_CURR_USER,
  activeLocation,
  caller_id_enabled,
  country_code,
  isPracticeAdmin,
  locations,
  phoneNumbers,
  practiceName,
  timezone,
  username,
})

export const setActiveLocation = activeLocation => ({
  type: AT.ACCT_SET_ACTIVE_LOC,
  activeLocation,
})

export const setUserAuthorizations = ({
  tier,
  products,
  remaining_blast_messages,
  remaining_mms_messages,
  has_plum,
  has_unknown_texting,
  pms_type,
  pms_version,
  use_correspondence_values,
}) => ({
  type: AT.ACCT_AUTHORIZATIONS,
  tier,
  products,
  remainingBlastMessages: remaining_blast_messages,
  remainingMmsMessages: remaining_mms_messages,
  hasPlum: has_plum,
  hasUnknownTexting: has_unknown_texting,
  pmsType: pms_type,
  pmsVersion: pms_version,
  useCorrespondenceValues: use_correspondence_values,
})

export const userLoginSucc = () => ({ type: AT.ACCT_LOGIN_SUCC })

export const fetchCurrentUser = () => dispatch => {
  dispatch({ type: AT.ACCT_FETCHING })

  return fetchApi('/account', 'GET').then(response => {
    // send error to sentry if no products
    if (response.products.length < 1) {
      logException(
        new Error(`no products for user ${JSON.stringify(response)}`),
      )
    }

    moment.tz.setDefault(response.timezone)
    dispatch(setCurrentUser(response))
    dispatch(setUserAuthorizations(response))

    if (tokenStorage.get()) {
      dispatch(userLoginSucc())
    }

    dispatch({ type: AT.ACCT_FETCHED })
  })
}

export const postUserLogin = (email, password) => dispatch => {
  const url = `${REACT_APP_API_BASE_URL}/users/sign_in`

  const isUrlVerbatim = true
  const body = JSON.stringify({
    user: {
      email,
      password,
    },
  })

  return fetchApi(url, 'POST', { isUrlVerbatim, body }).then(response => {
    tokenStorage.set(response.token)
    dispatch(userLoginSucc())
  })
}

export const setPreviousUrl = previous => ({
  type: AT.ACCT_PREV_URL,
  previous,
})

export const toggleCallerId = callerIdEnabled => dispatch => {
  const body = JSON.stringify({
    caller_id_enabled: !callerIdEnabled,
  })
  fetchApi('/account', 'POST', { body }).catch(error => {
    dispatch({ type: AT.ACCT_TOGGLE_CALLER_ID })
    logException(new Error(`${error}`))
  })

  dispatch({ type: AT.ACCT_TOGGLE_CALLER_ID })
}

export const updateRemainingBlastMessages = remainingBlastMessages => dispatch => {
  dispatch({
    type: AT.ACCT_UPDATE_REMAINING_BLAST_MESSAGES,
    remainingBlastMessages,
  })
}

export const updateRemainingMmsMessages = remainingMmsMessages => dispatch => {
  dispatch({
    type: AT.ACCT_UPDATE_REMAINING_MMS_MESSAGES,
    remainingMmsMessages,
  })
}



// WEBPACK FOOTER //
// ./src/state/actions/account.js